/**
 * The support service is not deployed (operator ruling 2026-10-12, answer 4 of
 * KG record 2026-10-12-rob-s-eight-answers-of-2026-10-12-second-set.md), so the
 * Support pages say so instead of reporting a failure (operator ruling
 * 2026-10-16).
 *
 * On admin.aaim.com the load balancer sends /api/v1/support/* to
 * platform-admin-api, which serves no such route and answers Express's 404
 * page. Under docker-compose the SPA nginx dead default answers 404
 * {"error":"route_not_found"}. A 503 means the same. A 404 the support service
 * itself sends carries the spec's ErrorBody (support-platform.openapi.yaml) and
 * keeps its meaning, such as "Case not found".
 */

import { Alert } from '@aaimplatform/ui';

export const SUPPORT_SERVICE_MISSING_TITLE = 'The support service is not available';

export class SupportServiceMissingError extends Error {
  constructor() {
    super(SUPPORT_SERVICE_MISSING_TITLE);
    this.name = 'SupportServiceMissingError';
  }
}

export function isSupportServiceMissing(response: { status: number } | undefined, error: unknown): boolean {
  const status = response?.status;
  if (status === 503) return true;
  if (status !== 404) return false;
  if (typeof error !== 'object' || error === null) return true;
  const code = (error as { error?: unknown }).error;
  return code === 'route_not_found' || typeof code !== 'string';
}

/** The error to throw for a failed support call: the missing-service error, or a plain one with `fallback`. */
export function supportFailure(response: { status: number } | undefined, error: unknown, fallback: string): Error {
  return isSupportServiceMissing(response, error) ? new SupportServiceMissingError() : new Error(fallback);
}

export function SupportServiceNotice() {
  return (
    <Alert type="warning" title={SUPPORT_SERVICE_MISSING_TITLE}>
      The support service did not answer this page&apos;s requests, so support cases cannot be read or opened from
      this page.
    </Alert>
  );
}
